import type { GameMode } from '../../shared/modes';
import { versusBlockFeature, type ProfileBlockFeature } from '../../shared/profile-blocks';
import type { Screen } from './navigation';

export function destinationBlockFeature(
  screen: Screen,
  mode: GameMode,
  hasRoomInfo: boolean,
  isHost: boolean,
): ProfileBlockFeature | null {
  if (
    screen === 'leaderboard' ||
    screen === 'solo' ||
    screen === 'versus' ||
    screen === 'host' ||
    screen === 'join' ||
    screen === 'competitive'
  )
    return screen === 'leaderboard' ? 'leaderboards' : screen;
  if (screen === 'archive' || screen === 'menu' || screen === 'settings' || !hasRoomInfo) return null;
  return mode === 'versus' ? versusBlockFeature(isHost) : mode;
}
